import { Link } from "react-router-dom";
import { MessageSquare, Radar, ShieldCheck, Compass } from "lucide-react";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { GlassCard } from "@/components/GlassCard";
import { Reveal, SectionKicker } from "@/components/Reveal";
import SEO from "@/components/SEO";
import { container, goldBtn } from "@/lib/constants";

const CAPS = [
  [Compass, "Understand the pipeline", "Ask ORLA to explain what is live, how it maps to your sectors, and where the desk is concentrating."],
  [Radar, "Check your mandate match", "ORLA assesses fit between available opportunities and your submitted mandate, in plain language."],
  [MessageSquare, "Request introductions", "Frame an introduction request conversationally; the desk reviews and coordinates every one."],
  [ShieldCheck, "Always under discretion", "ORLA never reveals proprietary methodology or other principals’ information. Discretion is the default."],
];

export default function OrlaPublic() {
  return (
    <PublicLayout>
      <SEO title="ORLA — the intelligence layer" description="ORLA is Prime Deal Gateway's AI intelligence layer for verified investors. Understand the pipeline, check mandate fit, and request introductions." />
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none"
          style={{ background: "radial-gradient(900px 500px at 80% 0%, hsl(40 45% 55% / 0.10), transparent 55%)" }} />
        <div className={`relative ${container} py-20 lg:py-28`}>
          <Reveal>
            <SectionKicker>The intelligence layer</SectionKicker>
            <h1 className="pdg-serif text-4xl sm:text-6xl text-foreground max-w-3xl leading-[1.05]">ORLA</h1>
            <p className="mt-6 text-lg text-foreground/80 max-w-2xl leading-8">
              ORLA is the discreet intelligence layer available to verified investors — a
              conversational assistant that helps you navigate the pipeline and your mandate,
              without ever exposing how the desk sources.
            </p>
            <div className="mt-8">
              <Link to="/auth?tab=apply" className={goldBtn}>Apply for access to ORLA</Link>
            </div>
          </Reveal>
        </div>
      </section>
      <section className={`${container} pb-24`}>
        <div className="grid gap-6 md:grid-cols-2">
          {CAPS.map(([Icon, t, d], i) => (
            <Reveal key={t} delay={(i % 2) * 0.05}>
              <GlassCard className="p-8 h-full">
                <Icon size={22} className="text-[hsl(var(--pdg-gold))]" strokeWidth={1.5} />
                <h2 className="mt-5 pdg-serif text-2xl text-foreground">{t}</h2>
                <p className="mt-3 text-sm text-muted-foreground leading-7">{d}</p>
              </GlassCard>
            </Reveal>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
